export default __webpack_public_path__ + "ada8a3ae4db0a8fd692ca7f55700dca9.png";